import { useState } from 'react';
import { t } from '../i18n';
import { firstName, fmtDate } from '../lib/format';
import { AddCompanyLink, PendingCompaniesNotice } from './account/HomeAccount';
import { AnfragenCard, AnfragenNotices, RequestFormSheetHost } from './anfragen/HomeAnfragen';
import { RequestSheetHost } from './anfragen/RequestSheet';
import { BelegeCommentNotices, BelegeCta, BelegeListItem, BelegeMissingNotice } from './belege/HomeBelege';
import { BriefeCta, BriefeNotices } from './briefe/HomeBriefe';
import { ChatListItem, ChatNotice } from './chat/HomeChat';
import { useClientApp } from './context';
import { WebPushNotice } from './HomePush';
import { DokSheetHost } from './dokumente/DokSheet';
import { DokumenteCard, DokumenteListItem, DokumenteNotices } from './dokumente/HomeDokumente';
import { FiledCard, FristenNotices, TaxesCard, UstvaCard } from './fristen/HomeFristen';
import { UstvaPruefenCard } from './fristen/UstvaPruefen';
import { JaListItem } from './jahresabschluss/HomeJa';
import { ProtokollSheetHost } from './fristen/ProtokollSheet';
import { BwaSheetHost } from './guv/BwaSheet';
import { BwaCard, GuvCard, GuvNotices } from './guv/HomeGuv';
import { LohnListItem, LohnNotices } from './lohn/HomeLohn';
import { usePage } from './page';
import { RechnungenListItem, RechnungenNotices } from './rechnungen/HomeRechnungen';

// Übersicht der Mandanten-App (Reihenfolge wie in der Demo): Begrüßung, Firmenwahl, Hinweise, Gewinn und Verlust,
// nächste UStVA, Belege- und Brief-Aufruf, fällige und übermittelte Umsatzsteuer, BWA, Dokumente (Ordner und neueste
// von der Kanzlei), sonstige Unterlagen, Bereiche (zuletzt Rechnungen).
export function Home() {
  usePage({ title: 'Elbcons', nav: 'start' });
  const { me, clients, clientName } = useClientApp();
  const [selected, setSelected] = useState(clients[0]!.id);
  const clientId = clients.some((c) => c.id === selected) ? selected : clients[0]!.id;
  const one = clients.length === 1;

  return (
    <>
      <div className="hello">
        <h2>{t('Hallo {name}', { name: firstName(me.user.name) })}</h2>
        <p>
          {one
            ? t('{name} · Ihre Übersicht für heute, {date}.', { name: clients[0]!.name, date: fmtDate(new Date()) })
            : t('Ihre Übersicht für heute, {date}.', { date: fmtDate(new Date()) })}
        </p>
        {!one && (
          <div className="chips" role="group" aria-label={t('Firma')}>
            {clients.map((c) => (
              <button
                key={c.id}
                type="button"
                className="chip"
                aria-pressed={c.id === clientId}
                onClick={() => setSelected(c.id)}
              >
                {c.name.replace(' GmbH', '')}
              </button>
            ))}
          </div>
        )}
      </div>
      <PendingCompaniesNotice />
      <BelegeMissingNotice />
      <ChatNotice />
      <BelegeCommentNotices />
      <LohnNotices />
      <BriefeNotices />
      <AnfragenNotices />
      <FristenNotices />
      <GuvNotices />
      <DokumenteNotices />
      <RechnungenNotices />
      <WebPushNotice />
      <GuvCard clientId={clientId} />
      <UstvaPruefenCard clientId={clientId} />
      <UstvaCard clientId={clientId} />
      <BelegeCta clientId={clientId} />
      <BriefeCta clientId={clientId} />
      <TaxesCard clientId={clientId} />
      <FiledCard clientId={clientId} />
      <BwaCard clientId={clientId} />
      <DokumenteCard clientId={clientId} />
      <AnfragenCard clientId={clientId} />
      <div className="list">
        <BelegeListItem clientId={clientId} />
        <DokumenteListItem clientId={clientId} />
        <LohnListItem clientId={clientId} />
        <JaListItem clientId={clientId} />
        <ChatListItem />
        <RechnungenListItem clientId={clientId} />
      </div>
      <AddCompanyLink />
      <RequestSheetHost />
      <ProtokollSheetHost />
      <BwaSheetHost />
      <DokSheetHost />
      <RequestFormSheetHost clientId={clientId} clientName={clientName(clientId)} />
    </>
  );
}
